const formatPhoneNumber = (number) => {
  if (number && number.length > 0) {
    const strippedNumber = number.replace(/[^0-9]/, '');

    if (strippedNumber.length === 10) {
      return (
        strippedNumber.slice(0, 3) +
        '.' +
        strippedNumber.slice(3, 6) +
        '.' +
        strippedNumber.slice(-4)
      );
    }

    if (strippedNumber.length === 7) {
      return strippedNumber.slice(0, 2) + '.' + strippedNumber.slice(-4);
    }
  }
  return number;
};

const formatCurrency = (number) => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  });

  return formatter.format(number);
};

export { formatCurrency, formatPhoneNumber };
